import React from "react";
import styles from "./index.module.scss";
const InputTooltip = ({ children, text }) => {
    return (React.createElement("div", { className: styles.tooltipWrapper },
        children,
        React.createElement("div", { className: styles.tooltipContent },
            React.createElement("div", { className: styles.tooltipBox },
                React.createElement("p", { className: styles.tooltipText }, text)),
            React.createElement("div", { className: styles.tooltipCaret }))));
};
export default InputTooltip;
